import React from 'react';
import {Box, Checkbox, Flex, Radio} from '@chakra-ui/react';

export const SelectableOptionsContainer = ({
  children,
  componentType,
  isSelected,
  title,
  onClick,
}: React.PropsWithChildren<{
  componentType: 'checkbox' | 'radio';
  title: React.ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
}>) => {
  return (
    <Flex
      direction="column"
      gap="4"
      px="6"
      py="4"
      bgColor={isSelected ? 'kblue.50' : 'white'}
      border="1px solid"
      borderColor={isSelected ? 'kblue.500' : 'kgray.200'}
      borderRadius="lg"
      cursor="pointer"
      onClick={(e) => {
        // Prevent an issue causing the click event to be fired twice
        e.preventDefault();
        onClick?.();
      }}
      _hover={{
        bgColor: !isSelected && 'kgray.100',
      }}
    >
      <Flex alignItems="center" gap="4">
        {componentType === 'checkbox' && <Checkbox isChecked={isSelected} />}
        {componentType === 'radio' && <Radio isChecked={isSelected} />}
        <Box flex="1">{title}</Box>
      </Flex>
      {children}
    </Flex>
  );
};
